import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { listsActions, listsSelector } from '$store/lists';
import { Loader } from '$shared/components';
import { Header, List, ListItem, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import router from '$navigation/router';
import { LIST } from '$shared/constants/pages';
import './UsersLists.sass';
import { IcPlus28 } from '$assets';
import { showModal } from '$navigation/helper';

enum LISTS_KEYS {
  FOLLOWINGS = 'followings',
  SPONSORS = 'sponsors',
  PAID_MESSAGES = 'paidMessages',
  TIPS = 'tips',
  TELEGRAM = 'telegram',
  SUBSCRIBERS = 'subscribers',
  REFERRALS = 'referrals',
}

const LISTS_ORDER = [
  LISTS_KEYS.FOLLOWINGS,
  LISTS_KEYS.SPONSORS,
  LISTS_KEYS.PAID_MESSAGES,
  LISTS_KEYS.TIPS,
  LISTS_KEYS.SUBSCRIBERS,
  LISTS_KEYS.TELEGRAM,
  LISTS_KEYS.REFERRALS,
];

export const UsersLists = () => {
  const { lists, isLoading, custom } = useSelector(listsSelector);
  const dispatch = useDispatch();
  const t = useTranslator();

  useEffect(() => {
    dispatch(listsActions.loadLists());
  }, []);

  const listsArray = useMemo(() => {
    return LISTS_ORDER.map((list) => lists[list])
      .filter((list) => list)
      .concat(custom);
  }, [lists, custom]);

  function renderContent() {
    if (!listsArray.length && isLoading) {
      return <Loader isWrapped />;
    }

    return (
      <ScrollView className="UsersLists">
        <List>
          {listsArray.map((list) => {
            const { listId } = list;

            return (
              <ListItem
                key={listId}
                indicator={list.count}
                onClick={() => router.navigate(LIST, { id: listId })}
                chevron
              >
                {list.title}
              </ListItem>
            );
          })}
        </List>
      </ScrollView>
    );
  }

  return (
    <>
      <Header
        showBackButton
        rightIcons={[
          {
            icon: <IcPlus28 />,
            onClick: () => {
              showModal('new_list');
            },
          },
        ]}
      >
        {t('lists_title')}
      </Header>
      {renderContent()}
    </>
  );
};
